import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Formik } from 'formik';
import * as yup from 'yup';

import {
  DetailsListLayoutMode,
  SelectionMode,
  Selection,
  IColumn,
} from 'office-ui-fabric-react/lib/DetailsList';
import { ShimmeredDetailsList } from 'office-ui-fabric-react/lib/ShimmeredDetailsList';
import { CommandBarButton, DefaultButton, ICommandBarStyles, IDialogContentProps } from 'office-ui-fabric-react';

import NoItems from '~/components/layout/NoItems';
import { Stack } from 'office-ui-fabric-react';
import Panel from '~/components/layout/Panel';
import { DeleteButton, PrimaryButton } from '~/components/Buttons';
import { InputAutocomplete, InputDate } from '~/components/Forms';
import CustomDialog from '~/components/CustomDialogFluentUI';

import { CCType, DataTypes as DataTypesCC } from '~/store/ducks/cc/types';
import { Creators as getCC } from '~/store/ducks/cc';

import { Creators as loadEmployeeCC } from '~/store/ducks/employees';
import { Creators as addEmployeeCC } from '~/store/ducks/employees';
import { Creators as delEmployeeCC } from '~/store/ducks/employees';
import { EmployeeCCType, EmployeeSelected } from '~/store/ducks/employees/types';
import { RootState } from "~/store/ducks";

interface IEmployeeAreasState {
  columns: IColumn[];
  items: EmployeeCCType[];
  selectionDetails: string;
  selectionCount: number;
  isPanelOpen: boolean;
  isDialogExcludeOpen: boolean;
  ccSelected: Partial<CCType> | null;
}

interface IEmployeeCCProps {
  employee: EmployeeSelected;
  idFuncionario: number;
  ccState: DataTypesCC;
  getCC: (SearchText?: string) => void;
  loadEmployeeCC: (idFuncionario: number) => void;
  addEmployeeCC: (idFuncionario: number, cc: EmployeeCCType) => void;
  delEmployeeCC: (idFuncionario: number, idHistCC: number) => void;
}

class EmployeeCC extends Component<IEmployeeCCProps, IEmployeeAreasState> {
  private _selection: Selection;
  private formRef: any;
  private timeout: number;

  constructor(props: IEmployeeCCProps) {
    super(props)

    const columns: IColumn[] = [
      {
        key: 'column1',
        name: 'Data',
        fieldName: 'dataHist',
        minWidth: 75,
        maxWidth: 75,
        isRowHeader: true,
        isResizable: true,
        // isSortedDescending: false,
        // sortAscendingAriaLabel: 'Sorted A to Z',
        // sortDescendingAriaLabel: 'Sorted Z to A',
        // onColumnClick: this._onColumnClick,
        data: 'data',
        isPadded: true,
        onRender: (item: EmployeeCCType) => moment(item.dataHist).format('DD/MM/YYYY')
      },
      {
        key: 'column2',
        name: 'ID',
        ariaLabel: 'Código id hist área',
        fieldName: 'idCC',
        isRowHeader: true,
        minWidth: 50,
        maxWidth: 50,
        isResizable: true,
        // isSortedDescending: false,
        // onColumnClick: this._onColumnClick
      },
      {
        key: 'column3',
        name: 'Centro de custo',
        fieldName: 'cc[nomeCC]',
        minWidth: 210,
        isRowHeader: true,
        isResizable: true,
        // isSortedDescending: false,
        // sortAscendingAriaLabel: 'Sorted A to Z',
        // sortDescendingAriaLabel: 'Sorted Z to A',
        // onColumnClick: this._onColumnClick,
        isPadded: true,
        onRender: (item: EmployeeCCType) => item.cc.nomeCC
      },
    ];

    this.state = {
      columns,
      items: [],
      selectionCount: 0,
      selectionDetails: '',
      isPanelOpen: false,
      isDialogExcludeOpen: false,
      ccSelected: null
    }

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({
          selectionDetails: this._getSelectionDetails(),
        });
      },
    });

    this.formRef = React.createRef();
    this.timeout = 0
  }

  componentDidMount() {
    const { loadEmployeeCC, idFuncionario, employee } = this.props;

    if (employee.cc?.length === 0 || employee.cc === null) {
      loadEmployeeCC(idFuncionario);
    }
  }

  componentDidUpdate(prevProps: IEmployeeCCProps) {
    if (prevProps.employee.success !== this.props.employee.success) {
      if (this.props.employee.success) {
        this.setState({ isPanelOpen: false })
      }
    }
  }

  _getSelectionDetails(): any {
    const selectionCount = this._selection.getSelectedCount();
    this.setState({ selectionCount });
    this._selection.getSelection();
  };

  cancelPanel = () => {
    this._selection.setAllSelected(false);
    this.setState({ isPanelOpen: false });
  };

  handleSubmit = () => {
    if (this.formRef.current) {
      this.formRef.current.handleSubmit();
    };
  };


  search = (text: string) => {
    if (text.trim()) {
      clearTimeout(this.timeout);
      this.timeout = window.setTimeout(() => {
        this.props.getCC(text)
      }, 700);
    };
  }

  excludeCC = () => {
    const { idFuncionario } = this.props;
    const idHistCC = (this._selection.getSelection()[0] as EmployeeCCType).idHistCC!
    this.props.delEmployeeCC(idFuncionario, idHistCC);
    this.setState({ isDialogExcludeOpen: false });
    this._selection.setAllSelected(false);
  }

  render() {
    const { columns, isPanelOpen, isDialogExcludeOpen, ccSelected } = this.state;
    const { employee, loadEmployeeCC, idFuncionario, addEmployeeCC, ccState } = this.props;
    const { cc, loadingItems, loadingAction } = employee;
    return (
      <>
        <Stack horizontal horizontalAlign="space-between" styles={{ root: { width: '100%' } }}>
          <Stack horizontal verticalAlign="center">
            <CommandBarButton styles={btnStyle} iconProps={{ iconName: 'Add' }} text="Adicionar Centro de Custo" onClick={() => this.setState({ isPanelOpen: true, ccSelected: null })} />
            {
              this._selection.getSelectedCount() > 0 &&
              <CommandBarButton styles={btnStyle} iconProps={{ iconName: 'Delete' }} text="Excluir" onClick={() => this.setState({ isDialogExcludeOpen: true })} />
            }
          </Stack>
          <Stack>
            <CommandBarButton styles={btnStyle} iconProps={{ iconName: 'Refresh' }} text="Atualizar" onClick={() => loadEmployeeCC(idFuncionario)} />
          </Stack>
        </Stack>
        {
          cc?.length === 0 ?
            <NoItems
              text="Não há histórico de centro de custo"
              icon="MapPin"
            />
            :
            <ShimmeredDetailsList
              items={cc ?? []}
              enableShimmer={loadingItems}
              columns={columns}
              selectionMode={SelectionMode.single}
              selection={this._selection}
              getKey={this._getKey}
              selectionPreservedOnEmptyClick={true}
              setKey="single"
              layoutMode={DetailsListLayoutMode.justified}
              isHeaderVisible={true}
              styles={{ root: { paddingTop: 0 } }}
            />
        }

        <Panel
          title={"Novo Centro de Custo"}
          open={isPanelOpen}
          onClose={() => this.cancelPanel()}
          footer={
            <Stack horizontal tokens={{ childrenGap: 10 }}>
              <DefaultButton onClick={() => this.cancelPanel()}>Cancelar</DefaultButton>
              <PrimaryButton onClick={this.handleSubmit} isLoading={loadingAction} text="Salvar" />
            </Stack>
          }
        >
          <Formik
            innerRef={this.formRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnChange={false}
            validateOnBlur={true}
            enableReinitialize
            onSubmit={(values) => {
              values.cc!.nomeCC = ccSelected?.nomeCC ?? '';
              addEmployeeCC(idFuncionario, values)
            }}
          >
            {({ handleSubmit, handleChange, values, errors, setFieldError, setFieldValue }) => (
              <form onSubmit={handleSubmit}>
                <InputDate
                  label="Data"
                  name='dataHist'
                  value={values.dataHist ? moment(values.dataHist) : null}
                  onChange={value => {
                    setFieldValue('dataHist', value)
                    setFieldError('dataHist', '')
                  }}
                  className="mt-2"
                  error={!!errors.dataHist}
                  helperText={errors.dataHist}
                  autoFocus
                />
                <InputAutocomplete
                  value={(ccSelected as CCType)}
                  onChange={(_, newValue) => {
                    this.setState({ ccSelected: newValue })
                    setFieldValue("idCC", newValue?.idCC);
                  }}
                  onInputChange={(_, newInputValue) => {
                    setFieldError("idCC", "");
                    this.search(newInputValue);
                  }}
                  getOptionLabel={(cc: CCType) => `${cc.idCC} - ${cc.nomeCC}`}
                  getOptionSelected={(option, value) => option.idCC === value.idCC}
                  options={ccState.data}
                  input={{
                    idInput: "cc",
                    labelInput: "Centro de Custo",
                    helperTextInput: errors.idCC,
                    errorInput: !!errors.idCC
                  }}
                />
              </form>
            )}
          </Formik>
        </Panel>

        <CustomDialog
          hidden={!isDialogExcludeOpen}
          onDismiss={() => this.setState({ isDialogExcludeOpen: false })}
          dialogContentProps={dialogContentProps}
        >
          <DefaultButton onClick={() => this.setState({ isDialogExcludeOpen: false })} text="Cancelar" />
          <DeleteButton onClick={() => this.excludeCC()} text="Excluir" />
        </CustomDialog>
      </>
    )
  }

  private _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
    const { columns } = this.state;
    const newColumns: IColumn[] = columns.slice();
    let items: EmployeeCCType[] = this.props.employee.cc ?? [];
    const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      };
    });
    const newItems = this._sort(items, currColumn.fieldName!, currColumn.isSortedDescending);
    this.setState({
      columns: newColumns,
      items: newItems,
    });
  };

  private _getKey(item: any, index?: number): any {
    if (item !== undefined)
      return item.key;
  };

  private _sort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    const key = columnKey as keyof T;
    const itemsSorted = items.sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
    return itemsSorted;
  };
}

const initialValues: EmployeeCCType = {
  dataHist: null,
  idCC: null,
  cc: {
    nomeCC: ''
  },
}

const dialogContentProps: IDialogContentProps = {
  title: 'Excluir?',
  closeButtonAriaLabel: 'Close',
  subText: 'Tem certeza de que deseja excluir este item?'
};


const validationSchema = yup.object().shape({
  dataHist: yup.date().nullable().typeError('Data inválida').required("Campo obrigatório"),
  idCC: yup.number().nullable().required("Campo obrigatório")
});


const btnStyle: Partial<ICommandBarStyles> = {
  root: {
    height: 44
  }
}

const mapStateToProps = (state: RootState) => ({
  employee: state.employeesReducer.itemSelected,
  ccState: state.ccReducer
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  ...loadEmployeeCC,
  ...addEmployeeCC,
  ...delEmployeeCC,
  ...getCC,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeCC);
